"use strict"

import React, { useEffect, useState } from "react"
import { Button } from "react-bootstrap"

import { parseDate, isNumber, stringifyDate } from "../../../utils"
import { isLTPM } from "../../../../components/shared_components_registration"
import { Required } from "../../../widgets/utils"

const registration = {
  x_axis_label: (intl) => (isLTPM ? intl.formatMessage({ id: "graphing.x.axis" }) : "X-Axis"),
  min_label: (intl) => (isLTPM ? intl.formatMessage({ id: "general.min" }) : "Min"),
  max_label: (intl) => (isLTPM ? intl.formatMessage({ id: "general.max" }) : "Max"),
  clear_text: (intl) => (isLTPM ? intl.formatMessage({ id: "general.clearButton" }) : "Clear"),
}

export default function XAxisRangeInputs({ intl, timeExtractor, zoomConfig, baseTime, xaxisdomain }) {
  const [min, setMin] = useState(null)
  const [max, setMax] = useState(null)
  const numberInput = timeExtractor.name === "Day"

  const warningBorderStyle = { border: "3px solid var(--lanzalake-red)" }

  // Format any passed date values to what input expects
  useEffect(() => {
    if (!numberInput) {
      setMin(stringifyDate(xaxisdomain[0]))
      setMax(stringifyDate(xaxisdomain[1]))
    } else {
      setMin(xaxisdomain[0])
      setMax(xaxisdomain[1])
    }
  }, [xaxisdomain])

  const zoomAxis = (e, range, setValue) => {
    e.preventDefault()
    const value = numberInput
      ? isNumber(e.target.value)
        ? parseFloat(e.target.value)
        : null
      : parseDate(e.target.value)
        ? e.target.value
        : null
    setValue(value)
    if (value || isNumber(value)) {
      const xAxisRange = numberInput ? range : range.map((x) => (x ? parseDate(x) : null))
      zoomConfig.zoomTime(
        xAxisRange[0] ? timeExtractor.difference(xAxisRange[0], baseTime) : xAxisRange[0],
        xAxisRange[1] ? timeExtractor.difference(xAxisRange[1], baseTime) : xAxisRange[1],
      )
    }
  }

  return (
    <>
      <div style={{ margin: "0", display: "flex", alignItems: "center" }}>
        <label>{registration.x_axis_label(intl)}:</label>
        <Button
          variant={"outline-primary"}
          style={{ marginLeft: "auto" }}
          className={"btn btn-sm"}
          onClick={(e) => {
            e.preventDefault()
            setMin(null)
            setMax(null)
            zoomConfig.unzoomTime()
          }}
        >
          {registration.clear_text(intl)}
        </Button>
      </div>

      <div className={"row"} style={{ margin: "0" }}>
        {numberInput ? (
          <>
            <div className={"col-6"} style={{ padding: "0" }}>
              <label>{registration.min_label(intl)}:</label>
              {!isNumber(min) && <Required />}
              <input
                type={"number"}
                onWheel={(e) => e.target.blur()}
                step={"0.1"}
                style={isNumber(min) ? { width: "100%" } : { width: "100%", ...warningBorderStyle }}
                value={isNumber(min) ? min : ""}
                onChange={(e) => zoomAxis(e, [e.target.value, max], setMin)}
              />
            </div>
            <div className={"col-6"} style={{ padding: "0" }}>
              <label>{registration.max_label(intl)}:</label>
              {!isNumber(max) && <Required />}
              <input
                type={"number"}
                onWheel={(e) => e.target.blur()}
                step={"0.1"}
                style={isNumber(max) ? { width: "100%" } : { width: "100%", ...warningBorderStyle }}
                value={isNumber(max) ? max : ""}
                onChange={(e) => zoomAxis(e, [min, e.target.value], setMax)}
              />
            </div>
          </>
        ) : (
          <div className={"col-12"} style={{ padding: "0" }}>
            <div style={{ marginBottom: "10px" }}>
              <label>{registration.min_label(intl)}:</label>
              {!min && <Required />}
              <input
                type={"datetime-local"}
                className={"form-control form-control-sm"}
                style={min ? {} : warningBorderStyle}
                value={min || ""}
                onChange={(e) => zoomAxis(e, [e.target.value, max], setMin)}
              />
            </div>
            <div>
              <label>{registration.max_label(intl)}:</label>
              {!max && <Required />}
              <input
                type={"datetime-local"}
                className={"form-control form-control-sm"}
                style={max ? {} : warningBorderStyle}
                value={max || ""}
                onChange={(e) => zoomAxis(e, [min, e.target.value], setMax)}
              />
            </div>
          </div>
        )}
      </div>
    </>
  )
}
